
import React from 'react'
import moment from 'moment'
import { getFormattedDate } from '../../../../common/services/common.service'

export default function ConfirmComponent({ quoteData, quoteDetails }: any) {

    return (


        <div className="w-full font-bold space-y-4">
            <div className="w-full">
                <div className="mb-6 ">
                    <h1> Order  Summary Details</h1>

                </div>
                <table className="w-full  font-semibold text-sm lg:text-base">
                    <tfoot>
                        <tr >
                            <td className="p-4 italic">{"Amount Quoted "}</td>
                            <td className="p-4"> {quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value}</td>
                        </tr>
                        <tr >
                            <td className="p-4 italic">{"Relocation Date"}</td>
                            <td className="p-4">
                                {quoteData?.date ? getFormattedDate(quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}

                            </td>
                        </tr>
                        <tr >
                            <td className="p-4 italic">{"Service Type"}</td>
                            <td className="p-4">{quoteDetails?.result?.Records[0]?.items[0]?.CategoryName}</td>
                        </tr>
                        <tr >
                            <td className="p-4 italic">{"Product Type"}</td>
                            <td className="p-4">{quoteDetails?.result?.Records[0]?.items[0]?.ProductTypeName}</td>
                        </tr>



                    </tfoot>
                </table>
            </div>



        </div>







    )
}